import { Link } from 'react-router-dom';
import { getFeaturedComic } from '@/mocks/comics';
import { getCategoryBySlug } from '@/mocks/categories';

interface CategoryCTAProps {
  categorySlug?: string;
}

export default function CategoryCTA({ categorySlug }: CategoryCTAProps) {
  const featured = getFeaturedComic();
  const category = categorySlug ? getCategoryBySlug(categorySlug) : undefined;

  return (
    <section className="flex flex-col lg:flex-row min-h-[420px]">
      <div className="lg:w-1/2 relative min-h-[300px] lg:min-h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Immersive%20anime%20illustration%20of%20a%20mysterious%20curio%20shop%20interior%20with%20warm%20golden%20lighting%2C%20magical%20artifacts%20on%20wooden%20shelves%2C%20cozy%20atmosphere%2C%20watercolor%20style%2C%20storybook%20quality%2C%20soft%20terracotta%20and%20cream%20tones&width=960&height=1200&seq=cta-cat-01&orientation=portrait"
          alt="洞洞杂货铺 - 当前精选"
          title="洞洞杂货铺高清漫画全集免费阅读下拉式"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
        <span className="absolute top-6 left-6 text-xs font-medium text-white/80 bg-black/20 px-3 py-1.5 rounded-full backdrop-blur-sm">
          当前精选
        </span>
        <div className="absolute bottom-8 left-6 right-6">
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
            洞洞
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight">
            杂货铺
          </p>
          <p className="font-heading text-xl md:text-2xl font-semibold text-white/80 mt-2">
            连载中
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center px-6 md:px-12 py-12 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            开始阅读
          </h2>
          <p className="mt-5 text-foreground-600 leading-relaxed">
            {category
              ? `探索「${category.name}」分类下的 ${category.comicCount} 部漫画作品。高清画质，下拉式流畅阅读体验，让每一页都成为视觉享受。`
              : '178漫画网拥有丰富的漫画资源库，涵盖多种类型。高清画质，下拉式流畅阅读体验，让每一页都成为视觉享受。'}
          </p>
          {featured && (
            <Link
              to={`/comic/${featured.slug}`}
              className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-white text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读 <i className="ri-arrow-right-line" />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}